// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/css/font-awesome.css
// module id = 2148
// module chunks = 0